import { TFunction } from "i18next";
import validator from "validator";
import { z } from "zod";

export const getAddressFormSchema = (t: TFunction) => {
  return z.object({
    streetType: z.string().max(255).nullable().optional(),
    address: z
      .string()
      .trim()
      .min(1, t("entities.entity.addresses.errors.address-required")),doorNumberId: z.number().positive().nullable().optional(),
    doorNumber: z.string().max(255).nullable().optional(),
    floor: z.string().max(255).nullable().optional(),
    locality: z
      .string()
      .trim()
      .min(1, t("entities.entity.addresses.errors.locality-required")),
    zipCode: z
      .string()
      .trim()
      .min(1, t("entities.entity.addresses.errors.zipcode-required"))
      .refine((val) => validator.isNumeric(val), {
        message: t("entities.entity.addresses.errors.zipcode-numeric"),
      }),

    zipArea: z
      .string()
      .trim()
      .min(1, t("entities.entity.addresses.errors.ziparea-required"))
      .refine((val) => validator.isNumeric(val), {
        message: t("entities.entity.addresses.errors.ziparea-numeric"),
      }),
    freguesiaId: z.number().positive().nullable(),
  });
};

export type AddressForm = z.infer<ReturnType<typeof getAddressFormSchema>>;
